export default __webpack_public_path__ + "static/shutterstock_5-30fa6eb2e58fa422377ae2ebba5cf225.jpg";